<template>
	<div class="nav" :class="{'change': isOpenMenu}">
		<div class="menu" @click="openMenu">
			<div v-if="!isOpenMenu">
				<img v-if="!blackMenu" src="../assets/img/menu.png" alt="">
				<img v-else src="../assets/img/menu_black.png" alt="">
			</div>
			<img v-else src="../assets/img/close.png" alt="">
		</div>
		<!-- 弹窗 -->
		<div class="popup" v-show="isOpenMenu">
			<div @click="openFun('/')">首页</div>
			<div @click="openFun('/bene')">我将无我</div>
			<div @click="openFun('/peace')">WORLD PEACE</div>
			<div class="line"></div>
			<div @click="openFun('/about')">关于我们</div>
			<div @click="openFun('/contact')">联系我们</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				isOpenMenu: false,
			}
		},
		props: {
			blackMenu: Boolean,
		},
		methods: {
			openMenu() {
				this.isOpenMenu = !this.isOpenMenu;
				console.log('dakai');
			},
			openFun(path) {
				if (this.$route.path == path) {
					this.isOpenMenu = !this.isOpenMenu;
					return;
				}
				console.log(this.$route.path, '----', path); 
				this.$router.push(path);
			}
		}
	}
</script>

<style scoped>
	.nav {
		
	}
	.change {
		background: #fff;
		color: #111;
		width: 100%;
		position: absolute;
		z-index: 10;
		height: 100vh;
	}
	.menu img {
		width: 18px;
		height: 15px;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 50px;
		z-index: 100;
	}
	.popup {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		color: #111;
	}
	.popup div {
		margin-bottom: 30px;
	}
	.line {
		height: 1px;
		background-color: #C7C7C7;
	}
</style>
